<template>
  <div class="card flex flex-column h-full">
    <CustomerOrderList></CustomerOrderList>
  </div>
</template>

<script setup lang="ts">
import CustomerOrderList from '@/domains/orders/CustomerOrderList.vue'
import { Role } from '@/opendoors-api/client'
definePage({
  name: 'customer-order-list',
  meta: {
    requiredRoles: [Role.CUSTOMER]
  }
})
</script>

<style scoped></style>
